(function () {
    'use strict';

    angular
        .module('app')
        .controller('OptimisticConcurrencyDialogCtrl', OptimisticConcurrencyDialogCtrl);

    OptimisticConcurrencyDialogCtrl.$inject = ['$filter', 'DialogInstance', 'DialogService', 'objectType', 'objectBeingSaved', 'latestVersion'];

    /**
     * @ngdoc Controller
     *
     * @description
     * Show a dialog detailing optimistic concurrency check failure and offer the user options for how to
     * deal with it.
     *
     * @param {string} objectType - Name of the object type, will be used to construct the message on the dialog.
     * @param {object} objectBeingSaved - The object being saved.
     * @param {object} latestVersion - An object with the following properties:
     *   - {date} UpdatedDate
     *   - {number} UpdatedBy - May be null if the object was not updated by a user.
     *   - {string} UpdatedByPreviewNameText - May be null if details of the entity cannot be found or UpdatedBy is null.
     * 
     * @returns {promise} - A promise indicating what the user clicked in the dialog:
     *   - Cancel = rejected promise
     *   - OK = resolved promise
     */
    function OptimisticConcurrencyDialogCtrl($filter, DialogInstance, DialogService, objectType, objectBeingSaved, latestVersion) {
        /* jshint validthis:true */
        var vm = this;
        vm.objectType = 'object';
        Object.defineProperty(vm, 'lastChangedLabel', { get: getLastChangedLabel });
        Object.defineProperty(vm, 'objectIsEntity', {
            get: function () {
                return !_.isNil(objectBeingSaved) && objectBeingSaved.EntityTemplate;
            }
        });
        Object.defineProperty(vm, 'objectTypeUppercase', {
            get: function () {
                return vm.objectType.charAt(0).toUpperCase() + vm.objectType.substr(1);
            }
        });
        vm.showEntityChangeHistory = showEntityChangeHistory;
        vm.cancel = cancel;
        vm.ok = ok;

        activate();

        function activate() {
            if (!_.isNil(objectType)) {
                vm.objectType = objectType;
            }
        }

        function getLastChangedLabel() {
            // 'by Joe on 06/10/2017 4:27 PM'
            // OR
            // 'on 06/10/2017 4:27 PM'

            var label = '';

            if (latestVersion.UpdatedByPreviewNameText) {
                label += 'by ' + latestVersion.UpdatedByPreviewNameText + ' ';
            }

            label += 'on ' + $filter('date')(latestVersion.UpdatedDate, 'medium');

            return label;
        }

        /**
         * Show a dialog detailing entity change history.
         */
        function showEntityChangeHistory() {

            // Add a millisecond to get history for *AFTER* the UpdateDate.
            // To be really accurate we would need to work in microseconds, but that's a nuisance in JS so a millisecond will suffice.
            var updatedDateFrom = new Date(objectBeingSaved.UpdatedDate);
            updatedDateFrom.setMilliseconds(updatedDateFrom.getMilliseconds() + 1);

            DialogService.show({
                locals: {
                    entityId: objectBeingSaved.Id,
                    updatedDateFrom: updatedDateFrom,
                    title: objectBeingSaved.EntityTemplate.Name + ' History'
                },
                controller: 'EntityChangeHistoryDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/Entity/entity-change-history-dialog.tmpl.html',
                size: DialogService.sizes.extraLarge
            });
        }

        function cancel() {
            DialogInstance.cancel();
        }

        function ok() {
            DialogInstance.ok();
        }
    }
})();
